import { isAfter, startOfDay } from 'date-fns'

import { isCampaignNameValid } from '@albacross/frontend-utils'

export const campaignEditValidator = values => {
  const errors: Record<string, any> = {}

  if (values.status === 'accepted' && isAfter(startOfDay(new Date()), startOfDay(new Date(values.startDate)))) {
    errors.startDate = 'Start date must be greater or equal than actual date'
  }

  if (new Date(values.startDate) > new Date(values.endDate)) {
    errors.endDate = 'End date must be greater than start date'
  }

  if (isAfter(startOfDay(new Date()), startOfDay(new Date(values.endDate)))) {
    errors.endDate = 'End date must be greater or equal than actual date'
  }

  if (!isCampaignNameValid(values.title)) errors.title = 'Name is invalid'

  if (values.goalRtbImpressions < values.goalImpressions) {
    errors.goalRtbImpressions = 'Goal RTB impressions must be greater or equal than goal impressions' // eslint-disable-line
  }

  if (!values.title) errors.title = 'Name is required'

  if (!values.cpm) errors.cpm = 'CPM is required'

  if (!values.goalImpressions) errors.goalImpressions = 'Goal impressions is required'

  if (!values.goalRtbImpressions) errors.goalRtbImpressions = 'Goal RTB impressions is required'

  return errors
}

export const campaignChangedCustomerWarnings = values => {
  const warnings: Record<string, any> = {}

  if (!Object.keys(values).length) return warnings

  if (values.customer && values.customer.id !== values.customerId) {
    warnings.customer = "Stripe subscription won't change!"
  }

  return warnings
}
